import type { FingerprintMetric } from '../lib/types';
import { clamp, lerp } from '../lib/format';
import styles from './LinguisticFingerprint.module.css';

export function LinguisticFingerprint({ metrics, className }: { metrics: FingerprintMetric[]; className?: string }) {
  return (
    <div className={[styles.wrap, className].filter(Boolean).join(' ')}>
      <ul className={styles.list}>
        {metrics.map((m) => {
          const v = clamp(m.value, 0, 1);
          const opacity = lerp(0.4, 1, v);
          const pct = v * 100;
          return (
            <li key={m.label} className={styles.row} title={m.raw ? `${m.label} · ${m.raw}` : `${m.label} · ${(v * 100).toFixed(0)}`}>
              <span className={styles.label}>{m.label}</span>
              <div className={styles.barWrap}>
                <div className={styles.barTrack}>
                  <div
                    className={styles.barFill}
                    style={{ width: `${pct}%`, opacity }}
                  />
                </div>
                <span className={[styles.value, 'mono'].join(' ')}>{(v * 100).toFixed(0)}</span>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
